<template>
  <div class="notification-card">
    <header class="notification-header">
      <h4 class="notification-source">QRWaiter</h4>
      <span class="notification-time">18:22</span>
    </header>
    <p class="notification-content">
      wierbgkuywb4 gy erut bertbg oerbt uebrot nbeirnb liuern iuner nelrtn liern
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.notification-card {
  width: 90%;
  position: relative;
  margin: 0 auto 2.5vh;
  background: #ffffff;
  display: block;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 1.7vh;
  padding: 2.5vh;
}

.notification-source {
  font-size: 2.3vh;
  font-weight: 600;
  margin: 0;
  line-height: 1;
}

.notification-time {
  font-size: 2vh;
  line-height: 1;
  align-self: center;
  color: #a4a3a1;
}

.notification-content {
  font-size: 2vh;
  margin: 0;
  line-height: normal;
  padding-top: 1.1vh;
  color: #454543;
}

.notification-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
@media screen and (min-width: 768px) {
  .notification-card {
    width: 23.264vw;
    padding: 1.389vw;
    margin-bottom: 1.389vw;
  }

  h4.notification-source {
    font-size: 1.111vw;
    line-height: 1.25vw;
  }
  span.notification-time,
  p.notification-content {
    font-size: 0.972vw;
    line-height: 1.111vw;
  }
}
</style>
